import "./sass/styles.scss";

function initAjaxContentLoader() {
  $('[data-ajax-url]').on('click', function (e) {
    const ajaxUrl = $(this).data('ajax-url');
    const $button = $(this);

    if (ajaxUrl !== undefined && ajaxUrl !== '') {
      event.preventDefault();
      const $targetContainer = $('#' + $(this).data('ajax-target-container'));
      $.ajax({
        url: ajaxUrl,
        type: 'GET',
        success: function (result) {
          const $ajaxHelper = $(result).find('[data-ajax-content-container]');
          const ajaxContentSelector = $ajaxHelper.data('ajax-content-container');
          const $ajaxContent = $(result).find('#' + ajaxContentSelector);
          if ($ajaxContent.children().length > 0) {
            $targetContainer.append($ajaxContent.children());
            $targetContainer.children().each(function () {
              $(this).animate({ opacity: 1 });
            });
            const nextPageUrl = $ajaxHelper.data('ajax-url');
            if (nextPageUrl) {
              $button.attr('href', nextPageUrl);
              $button.attr('data-ajax-url', nextPageUrl);
              $button.data('ajax-url', nextPageUrl);
            } else {
              $button.animate({ opacity: 0 }, 400, function() {
                $(this).remove();
              });
            }
          } else {
            $button.animate({ opacity: 0 }, 400, function() {
              $(this).remove();
            });
          }
        }
      });
    }
  });
}

$(function () {
  /* eslint-disable no-undef */
  $(".marken li").click(function() {
    $(".marken li").removeClass('active');
    $(this).addClass('active');
  });

  initAjaxContentLoader();

  /* eslint-enable no-undef */
});


import $ from "jquery";
import "waypoints/lib/jquery.waypoints";
import {CountUp} from "countup.js";

//add count on counter
document.querySelectorAll('[data-counter]').forEach(function(counter) {
  let number = counter.querySelector('.number');
  let endpoint = parseInt(number.dataset.counterNumber);
  const countUp = new CountUp(number, endpoint);

  let waypoint = new Waypoint({
    element: counter,
    handler: function(direction) {
      if (direction === 'down') {
        if (!countUp.error) {
          countUp.start();
        } else {
          console.error(countUp.error);
        }
      }
    },
    offset: 'bottom-in-view'
  });
});

